import { ArtData } from '@/database/art'
import React, { ReactElement } from 'react'
import { ClaimData } from '@/database/claim'
import { Tooltip } from 'react-tooltip'

const ClaimsMadeTooltip = ({ artData }: { artData: ArtData }): ReactElement => {
    return (
        <Tooltip anchorSelect={'#claims-made' + artData.art.id} clickable>
            <div>
                {artData.claims
                    .filter((claimData) => claimData.castingArt.nft.tokenId === artData.art.nft.tokenId)
                    .map((claimData: ClaimData) => (
                        <p key={'#p-claims-made-' + claimData.claim.id}>
                            #{claimData.claim.castingArt.nft.tokenId}
                            <span className="gray">&nbsp;claims&nbsp;</span>#{claimData.claim.targetArt.nft.tokenId}
                            <span className="gray">&nbsp;for&nbsp;</span>
                            {parseFloat(claimData.claim.amount).toFixed(2)}
                        </p>
                    ))}
            </div>
        </Tooltip>
    )
}

export default ClaimsMadeTooltip
